/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./XYConfirmDialog.vue?vue&type=template&id=6e7e896d&scoped=true"
import script from "./XYConfirmDialog.vue?vue&type=script&lang=js"
export * from "./XYConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e896d",
  null
  
)

export default component.exports